export default __webpack_public_path__ + "8adf415aa6a8ccd2df273037b7364562.png";